import { Component, Input, OnInit, inject } from '@angular/core';
import { BtwChartModule } from '@between/ng-cdk/chart';
import { Guid } from 'guid-typescript';
import { IIndicatorStorageDto } from 'src/app/api-services/indicator-api/indicator-api.interfaces';
import { IIndicator } from './generic-indicator-analysis.interface';
import { BtwCardModule } from '@between/ng-cdk/card';
import { AnalysisApiService } from 'src/app/api-services/analysis-api/analysis-api.service';
import { BtwDialogService } from '@between/ng-cdk/dialog';
import { BtwToastService } from '@between/ng-cdk/toast';
import { EMPTY, switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { DailyDrillDownComponent } from 'src/app/daily-drill-down/daily-drill-down.component';
import { GetBankStatementDailyDrillDownDto } from 'src/app/api-services/bank-statement-api/bank-statement-api.interface';

@Component({
  selector: 'generic-indicator-analysis',
  standalone: true,
  imports: [BtwChartModule, BtwCardModule],
  templateUrl: './generic-indicator-analysis.component.html',
  styleUrl: './generic-indicator-analysis.component.scss'
})
export class GenericIndicatorAnalysisComponent implements OnInit {
  private readonly analysisApiService: AnalysisApiService = inject(AnalysisApiService);
  private readonly dialogService: BtwDialogService = inject(BtwDialogService);
  private readonly toastService: BtwToastService = inject(BtwToastService);
  selectedDates: Date[] = [];

  @Input({ required: true })
  analysisId!: Guid;

  @Input({ required: true })
  indicatorName!: string;

  @Input()
  description: string | undefined;

  dataSource: IIndicatorStorageDto[] | undefined;
  indicatorValuesDataSourcesMap = new Map<string, IIndicator[]>();

  ngOnInit(): void {
    this.analysisApiService.getIndicatorPerAnalysisId(this.indicatorName, this.analysisId).subscribe({
      next: (response: IIndicatorStorageDto[]) => {
        this.dataSource = response;
        this.setIndicatorValuesDataSources(response);
      }
    });
  }

  private setIndicatorValuesDataSources(data: IIndicatorStorageDto[]): void {
    const charts = data[0].specificIndicatorValues.map(i => i.name);

    for (let chart of charts) {
      const indicatorValuesDataSource = data.map(p => ({ date: p.date, value: p.specificIndicatorValues.find(f => f.name === chart)!.value }));
      this.indicatorValuesDataSourcesMap.set(chart, indicatorValuesDataSource);
    }
  }

  minDate(startDate: Date, endDate: Date): Date {
    return startDate < endDate ? startDate : endDate;
  }

  maxDate(startDate: Date, endDate: Date): Date {
    return startDate > endDate ? startDate : endDate;
  }

  handleSelected(data: any): void {
    const { x } = data;

    const index = this.selectedDates.findIndex(p => p.getTime() === x.getTime());
    if (index < 0) {
      this.selectedDates.push(x);
      if (this.selectedDates.length === 2) {
        var startDate = this.minDate(this.selectedDates[0], this.selectedDates[1]);
        var endDate = this.maxDate(this.selectedDates[0], this.selectedDates[1]);
        this.dialogService.open(DailyDrillDownComponent, {
          title: `Daily drill down - Detailed analysis for dates ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`,
          data: {
            startDate: startDate,
            endDate: endDate,
            indicatorName: this.indicatorName,
            indicatorAnalysisId: this.analysisId
          } as GetBankStatementDailyDrillDownDto
        })
      }
    }
  }

  handleUnselected(data: any): void {
    const { x } = data;
    console.log(x);

    const index = this.selectedDates.findIndex(p => p.getTime() === x.getTime());
    if (index > -1) {
      this.selectedDates.splice(index, 1);
    }
  }
}
